import React from 'react'
import { Panel } from '@wf-wfria/pioneer-core'

export function ModalDialog({
	className,
	children,
	footer = null,
	headerDock = null,
	title,
	onClose,
	height = null,
	width = null,
	open,
	elementToFocusOnClose,
	isFullScreen,
}) {
	if (!!elementToFocusOnClose) {
		return (
			<Panel
				className={className}
				onClose={onClose}
				open={open}
				title={title}
				footer={footer}
				headerDock={headerDock}
				height={height}
				width={width}
				elementToFocusOnClose={elementToFocusOnClose}
				{...(isFullScreen && { fullScreen: true })}
			>
				{children}
			</Panel>
		)
	}
	return (
		<Panel
			className={className}
			onClose={onClose}
			open={open}
			title={title}
			footer={footer}
			headerDock={headerDock}
			height={height}
			width={width}
			trigger={<button style={{ display: 'none' }} />}
			{...(isFullScreen && { fullScreen: true })}
		>
			{children}
		</Panel>
	)
}
